module.exports = __webpack_public_path__ + "img/upperabs-mesomorph-female.a6f1b1e7.svg";